/* Rawtorque — No Cost EMI Card Badge
   File: assets/rt-card-emi.js
   Injects below .price.s1pr on cards >= ₹10,000
   Skips template-product (PDP uses rt-emi-strip.liquid)
*/
(function () {

  var MIN_PAISE   = 1000000;  /* ₹10,000 */
  var EMI_MONTHS  = 3;
  var INTEREST_PA = 24;       /* % p.a. flat — industry standard */

  /* ── helpers ── */
  function parsePaise(text) {
    var m = text.match(/[\d,]+\.?\d*/);
    if (!m) return 0;
    var r = parseFloat(m[0].replace(/,/g, ''));
    return isNaN(r) ? 0 : Math.round(r * 100);
  }

  function fmtINR(paise) {
    return '\u20b9' + (paise / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }

  function getPrice(priceEl) {
    var clone = priceEl.cloneNode(true);
    ['old-price','price-varies','rt-card-emi','rt-you-save','small'].forEach(function (c) {
      var el = clone.querySelector('.' + c);
      if (el) el.remove();
    });
    return parsePaise(clone.textContent.trim());
  }

  /* ── build badge HTML ── */
  function buildBadge(price) {
    var emiRs     = Math.round(price / EMI_MONTHS / 100);
    var savingsRs = Math.round(price * (INTEREST_PA / 100) * (EMI_MONTHS / 12) / 100);

    var wrap = document.createElement('div');
    wrap.className = 'rt-card-emi';

    /* Option D: minimal text row — no box, just icon + text */
    wrap.innerHTML =
      '<span class="rt-card-emi__ico" aria-hidden="true">\uD83D\uDCB3</span>' +
      '<span class="rt-card-emi__tag">No Cost EMI</span>' +
      '<span class="rt-card-emi__dot" aria-hidden="true">·</span>' +
      '<span class="rt-card-emi__mo">₹' + emiRs.toLocaleString('en-IN') + '/mo</span>' +
      '<span class="rt-card-emi__dot" aria-hidden="true">·</span>' +
      '<span class="rt-card-emi__save">Save ₹' + savingsRs.toLocaleString('en-IN') + '</span>';

    return wrap;
  }

  /* ── inject after price element ── */
  function inject(priceEl) {
    if (document.body.classList.contains('template-product')) return;
    if (priceEl.dataset.rtEmiDone) return;

    var price = getPrice(priceEl);
    if (!price || price < MIN_PAISE) return;

    priceEl.dataset.rtEmiDone = '1';

    /* Find the right insertion point depending on context:
       1. Side cart: price inside .cols → insert after .cols
       2. Main cart page: price inside <header> inside <section> → insert after <section>
       3. Collection cards: no special parent → insert after price directly */
    var insertAfter = priceEl;
    var colsParent = priceEl.closest('.cols');
    var headerParent = priceEl.closest('header');
    var sectionParent = priceEl.closest('section');

    if (colsParent && colsParent.parentElement) {
      insertAfter = colsParent;
    } else if (headerParent && sectionParent && sectionParent.contains(headerParent)) {
      insertAfter = sectionParent;
    }

    insertAfter.insertAdjacentElement('afterend', buildBadge(price));
  }

  function run() {
    /* Exclude .mobile-hide prices — the main cart page renders two price elements
       per item (mobile-only + mobile-hide). We only inject on the mobile-only one
       since our badge is always full-width and works on both viewports. */
    document.querySelectorAll('.price.s1pr:not(.mobile-hide)').forEach(inject);
  }

  /* ── init ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* Re-run whenever Xtra re-renders the cart (AJAX open/update) */
  window.addEventListener('listCart', run);
  /* Also re-run on Shopify section loads */
  document.addEventListener('shopify:section:load', run);

  /* RT FIX (INP): replaced setInterval(500ms × 20) + body MutationObserver with
     a scoped observer watching only product card list containers.
     setInterval was firing 20 times over 10s regardless of DOM changes. */
  if (window.MutationObserver) {
    var _emiObs = new MutationObserver(function(ms) {
      for (var i = 0; i < ms.length; i++) {
        if (ms[i].addedNodes.length) { run(); break; }
      }
    });
    function _observeEmiContainers() {
      document.querySelectorAll('.l4cl, .l4ft, #cart, #content').forEach(function(el) {
        if (el._emiObserved) return;
        el._emiObserved = true;
        _emiObs.observe(el, { childList: true, subtree: true });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', _observeEmiContainers);
    } else {
      _observeEmiContainers();
    }
  }

})();